import React, { useState } from "react";
import { Typography } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Box } from "@mui/material";

const EDissues = () => {
  const [selectedOption, setSelectedOption] = useState("none");

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div className="MajorConcernsContainer">
      {/* Dropdpwn for Community Engagement Issues */}
      <Box sx={{ flexGrow: 1 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: {
              xs: "column", // Mobile: stack
              sm: "row", // Tablet/Desktop: inline
            },
            alignItems: {
              xs: "flex-start",
              sm: "center",
            },
            gap: 2, // adds spacing between text and dropdown
          }}
        >
          <Typography className="issues-area-helper">Key Issues In</Typography>

          <FormControl
            sx={{
              width: {
                xs: "100%",
                sm: 300,
              },
            }}
            className="AreaFormControl"
          >
            <Select
              labelId="Area-label"
              id="Area"
              value={selectedOption}
              onChange={handleChange}
              displayEmpty
              className="IssueAreaSelect"
            >
              <MenuItem value="none">
                <em>-- Select an area --</em>
              </MenuItem>
              <MenuItem value="CrossCreek">Cross Creek</MenuItem>
              <MenuItem value="Evinston">Evinston</MenuItem>
              <MenuItem value="Gordon">Gordon</MenuItem>
              <MenuItem value="Hawthorne">Hawthorne</MenuItem>
              <MenuItem value="IslandGrove">Island Grove</MenuItem>
              <MenuItem value="Melrose">Melrose</MenuItem>
              <MenuItem value="Micanopy">Micanopy</MenuItem>
              <MenuItem value="Monteocha">Monteocha</MenuItem>
              <MenuItem value="OrangeHeights">Orange Heights</MenuItem>
              <MenuItem value="Rochelle">Rochelle</MenuItem>
              <MenuItem value="Waldo">Waldo</MenuItem>
              <MenuItem value="Windsor">Windsor</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>
      {/* Concerns for selected are to be displayed */}
      <div className="MajorConcernsData">
        {selectedOption === "none" && (
          <Typography variant="body2">
            <p className="ZeroBottomMargin">
              Please select an area from the above dropdown to view economic
              development concers related to it.
            </p>
          </Typography>
        )}
        {selectedOption === "CrossCreek" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>A bait shop is needed</li>
            </ul>
          </Typography>
        )}
        {selectedOption === "OrangeHeights" && (
          <Typography
            variant="body1"
            style={{
              paddingLeft: "1%",
            }}
          >
            There is currently no data available for this area. If you have a
            comment, please fill out our{" "}
            <a target="_blank" href="https://wkf.ms/4jlqDeG" rel="noreferrer">
              form
            </a>
            .
          </Typography>
        )}
        {selectedOption === "Evinston" && (
          <Typography
            variant="body1"
            style={{
              paddingLeft: "1%",
            }}
          >
            There is currently no data available for this area. If you have a
            comment, please fill out our{" "}
            <a target="_blank" href="https://wkf.ms/4jlqDeG" rel="noreferrer">
              form
            </a>
            .
          </Typography>
        )}
        {selectedOption === "Gordon" && (
          <Typography
            variant="body1"
            style={{
              paddingLeft: "1%",
            }}
          >
            There is currently no data available for this area. If you have a
            comment, please fill out our{" "}
            <a target="_blank" href="https://wkf.ms/4jlqDeG" rel="noreferrer">
              form
            </a>
            .
          </Typography>
        )}
        {selectedOption === "Hawthorne" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>Increase job opportunities across various industries</li>
              <li>
                Improve water and sewer infrastructure to attract businesses
              </li>
              <li>
                Address substandard housing quality and increase housing
                availability
              </li>
              <li>
                Balance natural resource protection with industrial development
                needs
              </li>
              <li>Expand access to gas stations in underserved areas</li>
              <li>Capitalize on economic opportunities along Highway 301</li>
              <li>
                Address challenges with agricultural qualifications when
                rehabilitating land
              </li>
              <li>
                Increase availability of medical jobs and career opportunities
              </li>
              <li>
                Upgrade infrastructure (water, sewer, fiber) to support job
                growth
              </li>
              <li>
                Make industrial sites more attractive and development-ready
              </li>
              <li>Provide job and workforce training programs</li>
              <li>Simplify the building and development permitting process</li>
            </ul>
          </Typography>
        )}
        {selectedOption === "IslandGrove" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>Tire dumping on SE 201 and SE 203 needs attention</li>
              <li>
                The old convenience store is seen as an eyesore; residents want
                it repurposed
              </li>
              <li>
                County regulations seem to favor chain stores, limiting local
                business options
              </li>
              <li>Interest in using personal property for small businesses</li>
              <li>
                Residents want the old gas station and general store cleaned up
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Melrose" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                There is a strong need for living-wage jobs and small business
                support
              </li>
              <li>
                Residents want access to job training programs and more
                information about current local businesses to identify economic
                gaps
              </li>
              <li>
                The community is interested in bringing in a supermarket or
                local farmer’s market, while also ensuring food safety
              </li>
              <li>
                Challenges in farming due to soil conditions and overregulation
                were raised
              </li>
              <li>
                Residents are encouraged to explore small farmer grants and food
                safety training programs
              </li>
              <li>
                Ideas to revitalize Melrose’s downtown include repainting
                buildings, adding shady trees, and becoming a walkable “sidewalk
                community”
              </li>
              <li>
                Residents want to ensure new businesses fit the small-town
                character of Melrose and to support existing businesses by
                promoting them through platforms like Visit Gainesville
              </li>
              <li>
                Offer low-interest farm loans and start a tractor rental service
              </li>
              <li>
                No formal music festival proposal has been submitted yet, but
                residents want to stay informed if one moves forward
              </li>
              <li>
                Opinions are mixed Some see opportunities to grow local arts and
                attract youth, while others worry about noise, safety, traffic,
                & neighborhood impact
              </li>
              <li>
                Residents asked for transparency in the planning process and a
                chance for community voices to be heard
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Micanopy" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                Rehabilitate and repurpose the building in Micanopy on 441 and
                the Micanopy area near I-75
              </li>
              <li>
                Concerns about growth as Marion residents move closer to Alachua
                County
              </li>
              <li>
                Frustration with long permitting, construction, and inspection
                processes
              </li>
              <li>
                Encourage the opening of grocery stores and medical facilities
                in repurposed buildings
              </li>
              <li>Preserve wildflowers to promote environmental tourism</li>
              <li>
                Increase collaboration between the county and Micanopy to
                improve code enforcement and building department support
              </li>
              <li>
                Improve code enforcement to reduce insurance rate issues and
                ensure necessary repairs are made
              </li>
              <li>
                Ensure a balance between Micanopy’s charm/nature and economic
                development projects is maintained{" "}
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Monteocha" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                NE 21 Ave & CR 192 was previously zoned for both business and
                agriculture but is now zoned only for agriculture; desire to
                allow business zoning in the area again
              </li>

              <li>Interest in opening a small store and a country food spot</li>
              <li>
                Support for developing “mom and pop shops” and resident-owned
                restaurants
              </li>
              <li>
                Desire to preserve the small community while still allowing for
                new small businesses
              </li>
              <li>Family subdivisions on personal property </li>
              <li>
                Do not want Monteocha to reflect Haile Plantation in terms of
                population and housing density
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Rochelle" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                Desire for economic development but in a manner that does not
                interrupt Rochelle’s quiet feel
              </li>
              <li>Need for a grocery store</li>
              <li>
                Possibly develop the Masonic Lodge into a community center
              </li>
              <li>Internet service is horrible</li>
              <li>Junk vehicles on lakeshore need to be removed </li>
              <li>Put a gas station/convenience store on 20</li>
              <li>
                Push local businesses & requests information on small business
                grants
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Waldo" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                Empty downtown buildings and lack of parking discourage
                potential business owners and consumers
              </li>
              <li>Drainage issues need to be addressed</li>
              <li>
                Need more trade schools to prepare the local workforce for new
                opportunities
              </li>
              <li>Lack of a local workforce for emerging job opportunities</li>
              <li>No municipal water plant to support local development</li>
              <li>
                Establish a Waldo Passport for tourism to encourage visits to
                local assets
              </li>
              <li>
                Increase communication regarding county support for small
                businesses
              </li>
              <li>
                Revamp the downtown gas station with multiple attractions, such
                as food stores and gift shops
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Windsor" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                Reopen the Windsor lake and parks for surface water tourism
              </li>
              <li>
                There is a problem with junk north of Windsor along the east
                side of 26 near Paynes Prairie
              </li>
            </ul>
          </Typography>
        )}
      </div>
    </div>
  );
};

export default EDissues;
